import { PrismText } from '@prism-ui/react';
import './style.css';

export default function SalesRepInfo(props: any) {
  return <PrismText display="bodyL">{props.contactUS}</PrismText>;
}
